import { autoinject, computedFrom } from "aurelia-framework";
import { BaseActivityConfiguration } from "../base-activity-configuration";
import { QueryBuilder } from "../../../components/queries/query-builder";
import { WorkflowConfigurationService } from "../../../../services/workflow/workflow-configuration-service";
import { Reflection } from "../../../../utilities/reflection";

@autoinject()
export class ConditionalActivityConfiguration extends BaseActivityConfiguration {

    _queryBuilder: QueryBuilder;

    set queryBuilder(value: QueryBuilder) {
        this._queryBuilder = value;
        if (value && this.meta.clauses.length == 0) {
            setTimeout(() => {
                this.queryBuilder.addFilter(0);
            })
        }
    }

    @computedFrom(Reflection.getPropertyPath<ConditionalActivityConfiguration>(x => x._queryBuilder))
    get queryBuilder(): QueryBuilder {
        return this._queryBuilder;
    }

    constructor(workflowConfigurationService: WorkflowConfigurationService) {
        super(workflowConfigurationService);
    }

    onActivated() {
        if (!this.meta.clauses) {
            this.meta.clauses = [];
        }
        this.meta.entityUri = this.entity;
    }
}
